import { PrimaryButton } from '@acko-tech/building-blocks.ui.button';
import { useFetchParams } from 'hooks/useFetchParams';
import { LOB } from 'utils/constants';
import { DeviceCategory } from 'components/newPlan/constants';
import { getHHMM } from 'utils/date';
import { OrderStatus } from '../constants';
import * as Styles from './styles';

enum TabOptions {
    PENDING = 'Pending',
    COMPLETED = 'Completed',
}

interface IProps {
    selectedTab: TabOptions;
    deviceName: string;
    lastUpdatedAt: string;
    status: string;
    statusMessage: string;
    serialNumber: string;
    planName: string;
    coverage: string;
    mobileNumber: string;
    amount: number;
    deviceCategory: string;
    onClick: any;
    isBtnLoading: boolean;
    vin?: string;
}

function TransactionDetailsModal({
    selectedTab,
    deviceName,
    lastUpdatedAt,
    status,
    statusMessage,
    serialNumber,
    planName,
    coverage,
    mobileNumber,
    amount,
    deviceCategory,
    onClick,
    isBtnLoading,
    vin,
}: IProps) {
    const { lob } = useFetchParams();
    const getColors = () => {
        switch (status) {
            case OrderStatus.ORDER_CREATED:
                return {
                    color: '#5920C5',
                    background: '#EFE9FB',
                };
            default:
                return {
                    color: '#D83D37',
                    background: '#FBEAEA',
                };
        }
    };

    const { background, color } = getColors();

    return (
        <Styles.Wrapper>
            <Styles.ModalName>{deviceName}</Styles.ModalName>
            <Styles.LastUpdatedDate>
                Last updated {getHHMM(lastUpdatedAt)}
            </Styles.LastUpdatedDate>
            <Styles.StatusText background={background} color={color}>
                {statusMessage || status}
            </Styles.StatusText>
            <Styles.PlanDetailsWrapper>
                <Styles.RowWrapper>
                    <Styles.LabelText>Device model</Styles.LabelText>
                    <Styles.ValueText>{deviceName}</Styles.ValueText>
                </Styles.RowWrapper>
                <Styles.Hr />
                {lob === LOB.EMBEDDED && (
                    <>
                        <Styles.RowWrapper>
                            <Styles.LabelText>
                                {deviceCategory === DeviceCategory.MOBILE ||
                                deviceCategory === DeviceCategory.TABLET
                                    ? 'IMEI'
                                    : 'Serial Number'}
                            </Styles.LabelText>
                            <Styles.ValueText>{serialNumber}</Styles.ValueText>
                        </Styles.RowWrapper>
                        <Styles.Hr />
                        <Styles.RowWrapper>
                            <Styles.LabelText>Plan Name</Styles.LabelText>
                            <Styles.ValueText>{planName}</Styles.ValueText>
                        </Styles.RowWrapper>
                        <Styles.Hr />
                        <Styles.RowWrapper>
                            <Styles.LabelText>What’s covered</Styles.LabelText>
                            <Styles.ValueText>{coverage}</Styles.ValueText>
                        </Styles.RowWrapper>{' '}
                    </>
                )}
                {lob === LOB.AUTO && (
                    <>
                        <Styles.RowWrapper>
                            <Styles.LabelText>VIN</Styles.LabelText>
                            <Styles.ValueText>{vin}</Styles.ValueText>
                        </Styles.RowWrapper>
                        <Styles.Hr />
                        <Styles.RowWrapper>
                            <Styles.LabelText>Plan Name</Styles.LabelText>
                            <Styles.ValueText>{planName}</Styles.ValueText>
                        </Styles.RowWrapper>
                    </>
                )}
            </Styles.PlanDetailsWrapper>
            <Styles.CustomerDetailsWrapper>
                <Styles.CustomerMobileFlex>
                    <Styles.CustomerMobileText>
                        Customer mobile number
                    </Styles.CustomerMobileText>
                    <Styles.CustomerMobileNumber>
                        {mobileNumber}
                    </Styles.CustomerMobileNumber>
                </Styles.CustomerMobileFlex>
                <Styles.CustomerAmountFlex>
                    <Styles.CustomerMobileFlex>
                        <Styles.CustomerMobileText>
                            Amount
                        </Styles.CustomerMobileText>
                        <Styles.CustomerMobileNumber>
                            ₹{amount}
                        </Styles.CustomerMobileNumber>
                    </Styles.CustomerMobileFlex>
                </Styles.CustomerAmountFlex>
            </Styles.CustomerDetailsWrapper>
            {selectedTab === TabOptions.PENDING &&
                status !== OrderStatus.ORDER_LINK_EXPIRED &&
                status !== OrderStatus.PAYMENT_SUCCESS_BY_DEALER && (
                    <Styles.ResendLinkWrapper>
                        <PrimaryButton
                            loading={isBtnLoading}
                            isFullWidth={true}
                            size={'medium'}
                            onClick={() =>
                                onClick(
                                    status === OrderStatus.ORDER_CREATED
                                        ? 'resend'
                                        : 'pay_acko'
                                )
                            }
                        >
                            {status === OrderStatus.ORDER_CREATED
                                ? 'Resend link'
                                : 'Pay Acko'}
                        </PrimaryButton>
                    </Styles.ResendLinkWrapper>
                )}
            {selectedTab === TabOptions.PENDING &&
                status !== OrderStatus.ORDER_CREATED &&
                status !== OrderStatus.ORDER_LINK_EXPIRED && (
                    <Styles.ResendLinkText onClick={() => onClick('resend')}>
                        Resend link
                    </Styles.ResendLinkText>
                )}
        </Styles.Wrapper>
    );
}

export default TransactionDetailsModal;
